import { dateClient } from './date-client';
import { DateTime } from 'luxon';
export function transformDateToDayJs(date, timezone) {
    const unprocessedDate = new Date(date);
    return dateClient()
        .tz(timezone)
        .year(unprocessedDate.getFullYear())
        .month(unprocessedDate.getMonth())
        .date(unprocessedDate.getDate())
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0);
}
export function transformDayJstoDate(date) {
    return new Date(date.year(), date.month(), date.date(), date.hour(), date.minute(), date.second());
}
export function convertUTCToLocalDate(utcString, targetZone) {
    const local = DateTime.fromISO(utcString, { zone: 'utc' }).setZone(targetZone);
    return new Date(local.year, local.month - 1, local.day, local.hour, local.minute, local.second, local.millisecond);
}
export function convertLocalDateToUTC(localDate, localZone) {
    const date = DateTime.fromObject({
        year: localDate.getFullYear(),
        month: localDate.getMonth() + 1,
        day: localDate.getDate(),
        hour: localDate.getHours(),
        minute: localDate.getMinutes(),
        second: localDate.getSeconds(),
        millisecond: localDate.getMilliseconds()
    }, { zone: localZone });
    return date.toUTC().toISO();
}
